import { successAction, GET_EVENTS, CLEAN_EVENTS } from '../types';

const initialState = {
  data: [],
  total: 0,
};

const addEvents = (state, action) => {
  const { data, totalCount } = action.payload;

  return {
    ...state,
    data: [...state.data, ...data],
    total: totalCount,
  };
};

export default function(state = initialState, action) {
  switch (action.type) {
    case successAction(GET_EVENTS): {
      return addEvents(state, action);
    }
    case CLEAN_EVENTS: {
      return {
        ...state,
        data: [],
        total: 0,
      };
    }
    default:
      return state;
  }
}
